export const DEFAULT_COLORS = {
  primary: 'rgba(32, 154, 214, 1)',
  primaryHover: 'rgba(2, 119, 180, 1)',
  primaryBorderFocus: 'rgba(32, 154, 214, 1)',
  primaryLight: 'rgba(32, 154, 214, 0.12)',
  primarySubtle: 'rgba(32, 154, 214, 0.08)',
  primaryFocusRing: 'rgba(32, 154, 214, 0.1)',
  white: 'rgba(255, 255, 255, 1)',
  whiteTransparent: 'rgba(255, 255, 255, 0)',
  whiteOverlay: 'rgba(255, 255, 255, 0.95)',
  whiteBorderSubtle: 'rgba(255, 255, 255, 0.5)',
  whiteBorderHover: 'rgba(255, 255, 255, 0.8)',
  black: 'rgba(0,0,0,1)',
  error: 'rgba(212, 63, 88, 1)',
  errorLight: 'rgba(212, 63, 88, 0.12)',
  errorDark: '#c73e1d',
  dangerRed: '#de350b',
  dangerRedLight: '#ffebe6',
  warningAmber: 'rgba(255, 171, 0, 0.12)',
  warningAmberText: '#b27300',
  warningOrange: '#ff8b00',
  warningOrangeLight: '#fff4e6',
  successGreenLight: 'rgba(0, 150, 78, 0.12)',
  successGreenDark: '#00875a',
  successGreenBg: '#e6f7ef',
  grey4: 'rgba(0, 0, 0, 0.04)',
  grey5: 'rgba(0, 0, 0, 0.05)',
  grey6: 'rgba(0, 0, 0, 0.06)',
  grey8: 'rgba(0, 0, 0, 0.08)',
  grey10: 'rgba(0, 0, 0, 0.1)',
  grey12: 'rgba(0, 0, 0, 0.12)',
  grey13: 'rgba(0, 0, 0, 0.13)',
  grey23: 'rgba(0, 0, 0, 0.23)',
  grey25: 'rgba(0, 0, 0, 0.25)',
  grey40: 'rgba(0, 0, 0, 0.4)',
  grey44: 'rgba(0, 0, 0, 0.44)',
  grey50: 'rgba(0, 0, 0, 0.5)',
  grey60: 'rgba(0, 0, 0, 0.6)',
  grey63: 'rgba(0, 0, 0, 0.63)',
  grey70: 'rgba(0, 0, 0, 0.7)',
  grey80: 'rgba(0, 0, 0, 0.8)',
  grey87: 'rgba(0, 0, 0, 0.87)',
  grey94: 'rgba(0, 0, 0, 0.94)',
  green: '#388e3c',

  ink: {
    darkest: '#1a1a1a',
    dark: '#333',
    base: '#374151',
    muted: '#42526e',
    light: '#4b5563',
    lighter: '#5c5c5c',
    subtle: '#5f6368',
  },
  sky: {
    darkest: '#6b7280',
    dark: '#888',
    medium: '#666',
    base: '#999',
    muted: '#9ca3af',
    light: '#b0b0b0',
    lighter: '#ccc',
    subtle: '#d0d0d0',
    border: '#d1d5db',
    borderLight: '#ddd',
  },
  surface: {
    light: '#e0e0e0',
    lighter: '#e5e7eb',
    checkedBorder: '#e5e8ec',
    hover: '#eee',
    divider: '#f0f0f0',
    selected: '#f0f9ff',
    muted: '#f1f3f4',
    subtle: '#f3f4f6',
    background: '#f4f5f7',
    backgroundAlt: '#f5f5f5',
    dim: '#f8f9fa',
    lightest: '#f9fafb',
    white: '#fff',
  },
  accent: {
    teal: '#19aad2',
    salmon: '#d4886b',
    coral: '#e74c3c',
    primaryAlt: '#009ace',
    nearBlack: 'rgba(23, 23, 23, 1)',
    mutedGrey: 'rgba(103, 103, 103, 0.5)',
  },

  overlay: 'rgba(35, 35, 35, 0.4)',

  text: {
    primary: 'rgba(0, 0, 0, 0.93)',
    disabled: 'rgba(0, 0, 0, 0.125)',
    success: 'rgba(0, 150, 78, 1)',
  },
  controls: {
    grey: {
      background: 'rgba(244, 244, 244, 1)',
    },
    light: {
      background: 'rgba(255, 255, 255, 1)',
    },
  },
};
